import { render, staticRenderFns } from "./screenShopModal.vue?vue&type=template&id=36f63c05"
import script from "./screenShopModal.vue?vue&type=script&lang=ts"
export * from "./screenShopModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports